module.exports = __webpack_public_path__ + "img/EnclaveArmor.c001eefd.gif";